import React from 'react';
import {Col, Container, Modal, Row} from "react-bootstrap";
import css from '../css/ChooseGeofenceModal.module.css'

const ChooseGeofenceModal = ({active, title, geofences, onCancel, onSelect}) => {

    const handleSelect = (geofence) => {
        return () => {
            onSelect(geofence);
            onCancel();
        }
    }

    return (
        <Modal centered show={active} onHide={onCancel}>
            <Modal.Header className='modal-header' closeButton>
                <Modal.Title className='text-center'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row className={'justify-content-center'}>
                        {geofences.map(geofence => {
                            return (
                                <Col md={6} className={`d-flex justify-content-center align-items-center`} key={geofence.id}>
                                     <span onClick={handleSelect(geofence)} className={`${css.geofence} w-100 my-1`}>
                                        {geofence.name}
                                     </span>
                                </Col>
                            )
                        })}
                    </Row>
                </Container>
            </Modal.Body>

        </Modal>
    );
};

export default ChooseGeofenceModal;